import { IDevicesState } from '../models/IDevicesState';

/**
 * The initial state of the devices area.
 */
export const devicesInitialState: IDevicesState = {
  devicesById: new Map(),
  loading: true,
  loadingError: false,
  error: undefined,
  bitlockerIsLoading: true,
};
